import { Fragment } from 'react'
import { NavLink } from 'react-router-dom'
import { useResultsAvailable } from '@/hooks/useResultsAvailable'
import { Menu, Search } from 'lucide-react'
import { desktopHeaderRoutes } from '@/app/routes'
import { brandLogo } from '@/components/navigation/navigationAssets'
import { getNewsRedirectUrl } from '@/lib/data/news'

interface DesktopHeaderProps {
  onOpenMenu: () => void
}

export function DesktopHeader({ onOpenMenu }: DesktopHeaderProps) {
  const resultsAvailable = useResultsAvailable()
  return (
    <header className="desktop-header">
      <div className="desktop-header__inner">
        <NavLink to="/" className="desktop-header__brand" aria-label="Ecuador Elige, Elecciones Seccionales 2027">
          <img src={brandLogo} alt="El Telegrafo" />
          <span>Especial</span>
        </NavLink>

        <nav className="desktop-header__nav" aria-label="Navegacion principal">
          {desktopHeaderRoutes.filter((route) => route.id !== 'resultados' || resultsAvailable).map((route) => (
            <Fragment key={route.id}>
              <NavLink
                to={route.path}
                className={({ isActive }) =>
                  isActive ? 'desktop-header__link is-active' : 'desktop-header__link'
                }
              >
                {route.label}
              </NavLink>
              {route.id === 'home' ? (
                <a className="desktop-header__link" href={getNewsRedirectUrl()}>
                  Noticias
                </a>
              ) : null}
            </Fragment>
          ))}
        </nav>

        <div className="desktop-header__actions" aria-label="Acciones">
          <button type="button" className="desktop-header__menu" onClick={onOpenMenu} aria-label="Abrir menu">
            <Menu size={20} strokeWidth={2.5} />
          </button>
          <button type="button" className="desktop-header__search" aria-label="Buscar">
            <Search size={25} strokeWidth={1.8} />
          </button>
        </div>
      </div>
    </header>
  )
}
